// extracted by mini-css-extract-plugin
module.exports = {"detail-btn":"DetailBtn2_detail-btn__3i_aS","detail-btn-icon":"DetailBtn2_detail-btn-icon__2-3oY","normal":"DetailBtn2_normal__2wyA0","hover":"DetailBtn2_hover__3MKO7"};